/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminUser
 */
export interface AdminUser {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof AdminUser
     */
    'adminUserUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof AdminUser
     */
    'id': string;
    /**
     * 비밀번호
     * @type {string}
     * @memberof AdminUser
     */
    'password': string;
    /**
     * 이름
     * @type {string}
     * @memberof AdminUser
     */
    'name': string;
    /**
     * 등급
     * @type {string}
     * @memberof AdminUser
     */
    'rank': AdminUserRankEnum;
    /**
     * 로그인 제한 여부
     * @type {boolean}
     * @memberof AdminUser
     */
    'isLoginRestrict': boolean;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminUser
     */
    'createdAt': string;
    /**
     * 수정 일시
     * @type {string}
     * @memberof AdminUser
     */
    'updatedAt': string;
}

export const AdminUserRankEnum = {
    Normal: 'normal',
    Master: 'master'
} as const;

export type AdminUserRankEnum = typeof AdminUserRankEnum[keyof typeof AdminUserRankEnum];


